import { Component, OnInit } from '@angular/core';
import { FORMS, API, CODFUNC, GENERALES } from '../../../_config/strings';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import { Subject } from 'rxjs/Subject';
import swal from 'sweetalert2';
import { Usuario } from '../../../_model/Usuario';
import Swal from 'sweetalert2';
import { Cliente } from '../../../_model/Cliente';
import { Producto } from '../../../_model/Producto';
import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { Validators } from '@angular/forms';
import { materialize } from 'rxjs/operators';
import { find } from 'rxjs/operator/find';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';
import { element } from 'protractor';

@Component({
  selector: 'app-entradas-material',
  templateUrl: './entradas-material.component.html',
  styleUrls: ['./entradas-material.component.scss']
})
export class EntradasMaterialComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;

  public usuario: Usuario = new Usuario();
  idCliente: any;
  loginLoader = false;

  // arra's
  responseMensaje = [];
  arrayMaterial = [];
  arrayProductos = [];
  arrayProductosCantidad = [];

  inputs = 0;
  productoBitacora;
  arrayFolios;
  entrada;
  material;
  ordenTrabajoId;
  cliente = '';
  clienteNombre;
  direccionCliente = '';
  direccionObra = '';
  almacen = '';
  numeroContrato = '';
  fechaDia;
  fechaMovimiento;
  productos;
  contratoId;
  mayorCantidadEntradas;
  folio;
  noContrato = '';
  fechaEntrada = '';
  sucursal = '';

  constructor(
    private network: NetworkHelperService,
    private route: ActivatedRoute,
    private ruta: Router,
  ) {
    this.API = API;
    this.GENERALES = GENERALES;
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    this.idCliente = Number(this.route.snapshot.paramMap.get('idEntradas'));
  }

  ngOnInit() {
    this.gitMaterial();
    this.detallesOrden();
  }

  // En este metodo se llama el material para impresion
  gitMaterial() {
    this.network.callSecureService(
      this.API.user.productos,
      'GET',
      null)
      .subscribe((response: any) => {
      // console.log(response);
      // se recorre el response que contiene todo el material y se crea arrayMaterial en donde se inserta cantidad
      for (const producto of response.Mensaje) {
        this.arrayMaterial.push({
          codigo: producto.codigo,
          descrpcion: producto.descrpcion,
          familia: producto.familia,
          cantidad: 0
        });
      }
      // console.log(this.arrayMaterial);
      this.dtTrigger.next();
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      }
    );
  }
  // En este metodo se llama el material para impresion

  // Informacion que llena la tabla de orden de acuerdo al cliente
  detallesOrden() {
    const json = {
    clienteId: this.idCliente,
  };
  this.network.callSecureService(
    this.API.user.almacenes + '/' + this.API.user.clientes + '/' + this.API.user.ordenes,
    'POST',
    json
    ).subscribe((response: any) => {
      // console.log(response);
      this.clienteNombre = response.Mensaje[0].cliente.nombre;
      let pay;
      for (const orden of response.Mensaje) {
        if (orden.contrato.contratoId === pay) {
          // aqui se deben pushear los campos del array ya con un indice
          const busqeuda = this.responseMensaje.find(e => e.contrato.noContrato === orden.contrato.noContrato);
          busqeuda.descripcion = busqeuda.descripcion + ', ' + orden.descripcion;
          busqeuda.ordenes.push({
            ordenTrabajoId: orden.ordenTrabajoId
          });
          for (const materialUnico of orden.material) {
            const busquedaMaterialEnArrayExistente = busqeuda.material.find(elemento => elemento.codigo === materialUnico.codigo)
            if (busquedaMaterialEnArrayExistente) {
              busquedaMaterialEnArrayExistente.cantidad = Number(busquedaMaterialEnArrayExistente.cantidad) + Number(materialUnico.cantidad);
              busquedaMaterialEnArrayExistente.cantidadFaltante = Number(busquedaMaterialEnArrayExistente.cantidadFaltante) + Number(materialUnico.cantidadFaltante);
            } else {
              busqeuda.material.push(materialUnico);
            }
          }
        } else {
          // aqui se crean nuevos campos del array o nuevos rows
          this.responseMensaje.push({
            contrato: {noContrato: orden.contrato.noContrato, contratoId: orden.contrato.contratoId},
            descripcion: orden.descripcion,
            cliente: {nombre: orden.cliente.nombre, paterno: orden.cliente.paterno, rfc: orden.cliente.rfc},
            ordenes: [{ordenTrabajoId: orden.ordenTrabajoId}],
            material: orden.material
          });
          pay = orden.contrato.contratoId;
        }
      }
      console.log(this.responseMensaje);
    }, err => {
      Swal('Error', this.GENERALES.algoOcurrio, 'error');
      console.log(err);
    });
  }
  // Informacion que llena la tabla de orden de acuerdo al cliente

  // Envio de orden por id y el array material donde se guarda entradas
  guardarEntradas(entradas) {
    const json = {
      ordenes: entradas.ordenes,
      material: entradas.material
    };
    // console.log(json);
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.entradas,
      'POST',
      json
      ).subscribe((response: any) => {
      // console.log(response);
      if ( response.Estatus === 200 || response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje, 'success');
        this.ruta.navigate(['dashboard/menuAlmacen/clientesObra', this.idCliente]);
        console.log(this.responseMensaje);
        this.responseMensaje = [];
        this.detallesOrden();
      } else {
        Swal('Error', response.Mensaje.Estatus, 'error');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  // Metodo para traer el array de detalles orden con entradas en cero
  /*actualizar() {
    this.detallesOrden();
    swal('Correcto', 'Se actualizo correctamente el material', 'success');
  }*/
  // Metodo para traer el array de detalles orden con entradas en cero

  // Metodo que obtiene los folios de los movimientos
  bitacora(orden) {
    document.getElementById('tablaDeMaterial').style.display = 'none';
    // this.productoBitacora = [];
    this.contratoId = orden.contrato.contratoId;
    const json = {
      contratoId: orden.contrato.contratoId
      // movimientoId: this.movimientoId
      // fecha: this.fechaObra['formatted']
    };
    // console.log(json);
    this.network.callSecureService(
    this.API.user.almacenes + '/' + this.API.user.movimientos + '/' + this.API.user.entradas + '/' + this.API.user.folios,
    'POST',
    json
    ).subscribe((response: any) => {
      if (response.Estatus === 200) {
        this.arrayFolios = response.Mensaje;
        // console.log(response);
        // console.log(this.arrayFolios);
      } else {
        swal('Sin movimientos de entrada', 'No se han registrado entradas para este contrato, bitacora vacia', 'warning');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }
  // Metodo que obtiene los folios de los movimientos

  // Metodo que realiza la busqueda de los materiales deacuerdo al folio que se indique
  mostrarBitacora() {
    document.getElementById('tablaDeMaterial').style.display = 'block';
    const json = {
      contratoId: this.contratoId,
      folio: this.folio
    };
    console.log(json);
    this.network.callSecureService(
    this.API.user.almacenes + '/' + this.API.user.movimientos + '/' + this.API.user.entradas,
    'POST',
    json
    ).subscribe((response: any) => {
      if (response.Estatus === 200) {
        this.productoBitacora = response.Mensaje;
        this.noContrato = this.productoBitacora[0].contrato.noContrato;
        // this.fechaEntrada = moment(this.productoBitacora[0].fecha).locale('es').format('LL');
        this.fechaEntrada = this.productoBitacora[0].fecha.split('T')[0];
        this.fechaMovimiento = moment(this.fechaEntrada).locale('es').format('LL');
        this.sucursal = this.productoBitacora[0].sucursal;
        // console.log(this.productoBitacora);
      } else {
        swal('Sin movimientos de entrada', 'No se han registrado entradas para este contrato, bitacora vacia', 'warning');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }
  // Metodo que realiza la busqueda de los materiales deacuerdo al folio que se indique

  // Metodo que envia a impresion todos los materiales
  printRespaldo(): void {
    let printContents, popupWin;
    this.cliente = this.clienteNombre;
    // this.direccionObra = orden.obraCotizada;
    // this.almacen = orden.sucursal.nombreSuc;
    // this.numeroContrato = orden.contrato.noContrato;
    this.fechaDia = moment().locale('es').format('LL');

    // aqui haremos la asiganacion de los digitos a la impresion
    // primero realizamos el recorrido al material de cada obra
    /*for (const rowMaterial of orden.material)
    {
       //despues de recorrerlo encontraremos el mismo producto en el array de todos los productos
       const productoPorCodigo = this.arrayMaterial.find(e => Number(e.codigo) === Number(rowMaterial.codigo));

       //Comparacion para validar que no se imprima un numero mayor al de cantidad faltante
       if (rowMaterial.entradas <= rowMaterial.cantidadFaltante) {
         //al final indicamos que la cantidad de entradas va a guardarse en cantidad del array de materiales
        productoPorCodigo.cantidad = rowMaterial.entradas;
        console.log(productoPorCodigo.cantidad);
       } else {
         productoPorCodigo.cantidad = rowMaterial.cantidadFaltante;
       }
    }*/

    // aqui haremos la asiganacion de los digitos a la impresion
    // primero realizamos el recorrido al array de todos los materiales
    /*for(let producto of this.arrayMaterial) {
      producto.cantidad = 0;
      // despues de recorrerlo encontraremos el mismo producto en el array de productos por obra
      const productoPorCodigo = orden.material.find(e => Number(e.codigo) === Number(producto.codigo));
      if(productoPorCodigo) {
        if (productoPorCodigo.entradas <= productoPorCodigo.cantidadFaltante) {
          // al final indicamos que la cantidad de entradas va a guardarse en cantidad del array de materiales
          producto.cantidad = productoPorCodigo.entradas;
        } else {
      producto.cantidad = productoPorCodigo.cantidad;
      }
    }
  }*/

    // Colocamos un settime para que las variables sean cargadas antes de mostrar la impresion
    setTimeout(() => {
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=70%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial;
              font-weight: lighter;
              font-size: 12px;
            }
            .letraContratacion {
              font-family: Arial;
              font-weight: lighter;
              font-size: 9px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
            .tablas {
              border: 1px solid black;
            }
            .tablaMedida {
              width: 720px;
            }
            .tamagnoCeldas {
              height: 2px;
            }
            #lineaDivisora {
              border-left: 1px solid red;
              margin: 0px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }, 1000);
  }
  // Metodo que envia a impresion todos los materiales

  print(): void {
    let printContents, popupWin;
    this.cliente = this.clienteNombre;
    // this.direccionObra = orden.obraCotizada;
    this.almacen = this.sucursal;
    this.numeroContrato = this.noContrato;
    this.fechaDia = moment().locale('es').format('LL');
    this.fechaMovimiento = moment(this.fechaEntrada).locale('es').format('LL');
    /*this.productos = orden.material;
    // Recorrido en el cual insertaremos al objeto productos la variable cantidadMostrar
    this.productos.forEach(element => {
      if(element.entradas <= element.cantidadFaltante) {
        element['cantidadMostrar'] = element.entradas;
      } else { element['cantidadMostrar'] = element.cantidadFaltante; }
    });*/

    // Colocamos un settime para que las variables sean cargadas antes de mostrar la impresion
    setTimeout(() => {
    printContents = document.getElementById('print-section1').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=70%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial;
              font-weight: lighter;
              font-size: 12px;
            }
            .letraContratacion {
              font-family: Arial;
              font-weight: lighter;
              font-size: 9px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
            .tablas {
              border: 1px solid black;
            }
            .tablaMedida {
              width: 720px;
            }
            .tamagnoCeldas {
              height: 2px;
            }
            #lineaDivisora {
              border-left: 1px solid red;
              margin: 0px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }, 1000);
  }

}





// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/entradas-material/entradas-material.component.ts